import { render, staticRenderFns } from "./DefaultSurvey.vue?vue&type=template&id=5276f714&scoped=true"
import script from "./DefaultSurvey.vue?vue&type=script&lang=js"
export * from "./DefaultSurvey.vue?vue&type=script&lang=js"
import style0 from "./DefaultSurvey.vue?vue&type=style&index=0&id=5276f714&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5276f714",
  null
  
)

export default component.exports